import React, { useEffect } from "react";
import { Alert } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { clear } from "../../actions/alertAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faCopy } from "@fortawesome/free-solid-svg-icons";

const AlertWrapper = ({ variant, message, id }) => {
  const dispatch = useDispatch();
  const removeMessage = () => {
    dispatch(clear(id));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(clear(id));
    }, 4000);
    return () => clearTimeout(timer);
  }, [id, dispatch]);

  const copyMessageToClipboard = () => {
    navigator.clipboard.writeText(message);
  };

  return (
    <Alert
      variant={variant}
      onClose={() => removeMessage()}
      dismissible
      className="d-flex justify-content-between"
    >
      <span>{message}</span>
      <div
        style={{
          cursor: "pointer",
          border: "1px solid black",
          padding: "2px 5px",
          display: "flex",
          alignItems: "center",
          borderRadius: "4px",
          transition: "background-color 0.2s, transform 0.1s",
        }}
        onClick={copyMessageToClipboard}
        onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.95)")}
        onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = "#f0f0f0")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
      >
        <FontAwesomeIcon icon={faCopy} color="black" />
        <span style={{ marginLeft: "5px" }}>Copy</span>
      </div>
    </Alert>
  );
};

export default AlertWrapper;
